import { NominationWebsite } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationWebsite: (
  fetchContext: FetchContext,
  nominationWebsite: NominationWebsite,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationWebsite, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nomination-websites/${nominationWebsite.websiteId}`, {
    method: 'PUT',
    body: JSON.stringify(nominationWebsite),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination website'));
